export default "__VITE_ASSET__srVrp2gX__"